import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext } from '../../context/context';
import {
  updateCurrentRoom,
  updateMessage,
  updateNormalRoom,
  updateSelectedRoom,
} from '../../redux/user/room/roomSlice';
import { UploadImages } from '../../redux/user/room/roomsServiceSync';
import useImageDownloader from '../../utils/useImageDownloader';
import moment from 'moment';
import { PhotoView } from 'react-photo-view';
import { InfinitySpin } from 'react-loader-spinner';
import ScrollToBottom from 'react-scroll-to-bottom';

const UserNormalChat = () => {
  const dispatch = useDispatch();

  const messagesEndRef = useRef(null);

  const [typedMessage, setTypedMessage] = useState('');

  const [uploadImages, setUploadImages] = useState({ length: 0 });

  const { profile } = useSelector((state) => state.user_profile);

  const { socket } = useContext(AppContext);

  const {
    normalRooms,
    current_room,
    messages,
    selectedRoom,
    roomImageLoader,
    roomImageDetails,
  } = useSelector((state) => state.room);

  useEffect(() => {
    const requestHandler = async () => {
      if (profile) {
        const payload = {
          name: profile?.name,
          email: profile?.email,
          picture: profile?.profile_pic,
          roomOwner: profile?._id,
          room: `user-${profile?._id}-admin`,
        };

        await socket.emit('create-customer-user', payload);

        socket.emit('my-customer-new-user', { id: profile?._id });
      }
    };

    requestHandler();
  }, [profile]);

  socket.off('total-customer-user').on('total-customer-user', (payload) => {
    dispatch(updateNormalRoom(payload));
  });

  socket.off('normal-new-user').on('normal-new-user', (payload) => {
    dispatch(updateNormalRoom(payload));
  });

  socket
    .off('normal-room-messages')
    .on('normal-room-messages', (roomMessages) => {
      dispatch(updateMessage(roomMessages));
    });

  const JoinRoom = (room, currentRoom, isPublic = true) => {
    if (!profile) {
      return alert('please login');
    }

    socket.emit('customer-join-room', room.room, currentRoom, room);

    dispatch(updateCurrentRoom(room.room));

    dispatch(updateSelectedRoom(room));
  };

  useEffect(() => {
    if (normalRooms && profile) {
      JoinRoom({ room: `user-${profile?._id}-admin` }, '');
    }
  }, [normalRooms, profile]);

  const handleChange = (e) => {
    const { value } = e.target;
    setTypedMessage(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!typedMessage) return;

    let today = new Date();

    const minutes =
      today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();

    const time = today.getHours() + ':' + minutes;

    const roomId = current_room;
    if (uploadImages.length === 0) {
      socket.emit(
        'customer-message-room',
        roomId,
        typedMessage,
        profile,
        time,
        today.toISOString().split('T')[0],
        false,
        []
      );
    } else {
      const ImageDetails = roomImageDetails?.map((item) => {
        return {
          pic_url: item?.secure_url,
          pic_id: item?.public_id,
        };
      });

      socket.emit(
        'customer-message-room',
        roomId,
        typedMessage,
        profile,
        time,
        today.toISOString().split('T')[0],
        true,
        ImageDetails
      );

      setUploadImages({ length: 0 });
    }

    setTypedMessage('');
  };

  const handleUploadImage = async (e) => {
    const image = e.target.files;

    if (image) {
      const formData = new FormData();

      Array.from(image).forEach((file, i) => {
        formData.append(`file`, file);
      });

      await dispatch(UploadImages(formData));

      setUploadImages(image);
    }
  };

  useEffect(() => {
    if (roomImageDetails?.length > 0) {
      roomImageDetails.forEach((file, i) => {
        setTypedMessage((value) => value + ' ' + file?.secure_url);
      });
    }
  }, [roomImageDetails]);

  const { downloadImage } = useImageDownloader();

  return (
    <>
      <div class="row g-1">
        <div class="col-xxl-3">
          <div
            class="h-100"
            tabindex="-1"
            id="Contactoffcanvas"
            aria-labelledby="ContactoffcanvasLabel"
          >
            <div class="card position-relative overflow-hidden">
              <div class="card-header border-0 d-flex justify-content-between align-items-center">
                <h4 class="card-title">Chat</h4>
                <a
                  href="#user-setting"
                  class="fs-18"
                  type="button"
                  data-bs-toggle="offcanvas"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  {/* <i class="bx bx-cog"></i> */}
                </a>
              </div>

              <form class="chat-search px-3"></form>

              <div class="tab-content">
                <div class="tab-pane show active" id="chat-list">
                  <div class="px-3 mb-3 chat-setting-height" data-simplebar>
                    {normalRooms?.length > 0 &&
                      normalRooms?.map((item, key) => (
                        <a
                          href="javascript:void(0);"
                          class="text-body"
                          style={{ width: '100%' }}
                          onClick={() => JoinRoom(item)}
                        >
                          <div
                            class={`d-flex align-items-center p-2 ${
                              item?.room === current_room
                                ? 'bg-light bg-opacity-50 rounded-1'
                                : ''
                            }`}
                            style={{ width: '100%' }}
                          >
                            <div class="flex-shrink-0 position-relative">
                              <img
                                src={`/assets/img/avatar-profile-photo.png`}
                                class="me-2 rounded-circle"
                                height="36"
                                alt="avatar-2"
                                style={{ height: '36px', width: '36px' }}
                              />
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                              <h5 class="my-0">Admin</h5>
                              <p class="mt-1 mb-0 fs-13 text-muted d-flex align-items-end justify-content-between">
                                <span class="w-75">
                                  {moment(item?.lastTime).format('hh:mm:ss a')}
                                </span>

                                {item?.client_notification > 0 && (
                                  <span class="text-red-600">
                                    {item?.client_notification}
                                  </span>
                                )}
                              </p>
                            </div>
                          </div>
                        </a>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-9">
          <div class="card position-relative overflow-hidden">
            {current_room && (
              <>
                <div class="card-header d-flex align-items-center mh-100">
                  {/* <button
                    class="btn btn-light d-xxl-none d-flex align-items-center px-2 me-2"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#Contactoffcanvas"
                    aria-controls="Contactoffcanvas"
                  >
                    <i class="bx bx-menu fs-18"></i>
                  </button> */}

                  <div class="d-flex align-items-center">
                    <img
                      src={`/assets/img/avatar-profile-photo.png`}
                      class="me-2 rounded"
                      height="36"
                      alt="avatar-4"
                      style={{ height: '36px', width: '36px' }}
                    />
                    <div class="d-none d-md-flex flex-column">
                      <h5 class="my-0 fs-16 fw-semibold">
                        <a
                          data-bs-toggle="offcanvas"
                          href="#user-profile"
                          class="text-dark"
                        >
                          Admin
                        </a>
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="chat-box">
                  {/* <ul
                    class=""
                    
                  > */}
                  <ScrollToBottom
                    scrollViewClassName={
                      'chat-conversation-list p-3 chatbox-height h-[40%] overflow-y-auto'
                    }
                    ref={messagesEndRef}
                  >
                    {messages?.map((item, key) => (
                      <Fragment key={key}>
                        <li className="chat-date mt-0 flex items-center justify-center">
                          <span>{item?._id}</span>
                        </li>

                        {item?.messagesByDate?.map((data, ind) => (
                          <Fragment key={ind}>
                            {data?.from?._id !== profile?._id ? (
                              <>
                                {data?.image === true ? (
                                  <li class="clearfix">
                                    <div class="chat-conversation-text ms-0">
                                      <div class="d-flex">
                                        <div class="chat-ctext-wrap">
                                          {data?.imageDetails?.map(
                                            (image, i) => (
                                              <PhotoView
                                                src={
                                                  image?.pic_url ||
                                                  '/assets/images/small/img-1.jpg'
                                                }
                                              >
                                                <a href="javascript:void(0);">
                                                  <img
                                                    src={
                                                      image?.pic_url ||
                                                      '/assets/images/small/img-1.jpg'
                                                    }
                                                    alt="attachment"
                                                    style={{ height: '84px' }}
                                                    class="img-thumbnail me-1"
                                                  />
                                                </a>
                                              </PhotoView>
                                            )
                                          )}
                                          {/* <a href="javascript:void(0);">
                                            <img
                                              src="/assets/images/small/img-2.jpg"
                                              alt="attachment"
                                              style={{ height: '84px' }}
                                              class="img-thumbnail me-1"
                                            />
                                          </a>
                                          <a href="javascript:void(0);">
                                            <img
                                              src="/assets/images/small/img-3.jpg"
                                              alt="attachment"
                                              style={{ height: '84px' }}
                                              class="img-thumbnail me-1"
                                            />
                                          </a> */}
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1 ms-2">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                      </p>
                                    </div>
                                  </li>
                                ) : (
                                  <li class="clearfix">
                                    <div class="chat-conversation-text">
                                      <div class="d-flex">
                                        <div class="chat-ctext-wrap">
                                          <p>{data?.content}</p>
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1 ms-2">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                      </p>
                                    </div>
                                  </li>
                                )}
                              </>
                            ) : (
                              <>
                                {data?.image === true ? (
                                  <li class="clearfix odd">
                                    <div class="chat-conversation-text ms-0">
                                      <div class="d-flex justify-content-end">
                                        <div class="chat-ctext-wrap">
                                          {data?.imageDetails?.map(
                                            (image, i) => (
                                              <PhotoView
                                                src={
                                                  image?.pic_url ||
                                                  '/assets/images/small/img-1.jpg'
                                                }
                                              >
                                                <a href="javascript:void(0);">
                                                  <img
                                                    src={
                                                      image?.pic_url ||
                                                      '/assets/images/small/img-1.jpg'
                                                    }
                                                    alt="attachment"
                                                    style={{ height: '84px' }}
                                                    class="img-thumbnail me-1"
                                                  />
                                                </a>
                                              </PhotoView>
                                            )
                                          )}
                                          {/* <a href="javascript:void(0);">
                                            <img
                                              src="/assets/images/small/img-2.jpg"
                                              alt="attachment"
                                              style={{ height: '84px' }}
                                              class="img-thumbnail me-1"
                                            />
                                          </a>
                                          <a href="javascript:void(0);">
                                            <img
                                              src="/assets/images/small/img-3.jpg"
                                              alt="attachment"
                                              style={{ height: '84px' }}
                                              class="img-thumbnail me-1"
                                            />
                                          </a> */}
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1 ms-2">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                      </p>
                                    </div>
                                  </li>
                                ) : (
                                  <li class="clearfix odd">
                                    <div class="chat-conversation-text ms-0">
                                      <div class="d-flex justify-content-end">
                                        <div class="chat-ctext-wrap">
                                          <p className="text-white">
                                            {data?.content}
                                          </p>
                                        </div>
                                      </div>
                                      <p class="text-muted fs-12 mb-0 mt-1">
                                        {moment(data?.createdAt).format(
                                          'hh:mm:ss a'
                                        )}
                                        <i class="bx bx-check-double ms-1 text-primary"></i>
                                      </p>
                                    </div>
                                  </li>
                                )}
                              </>
                            )}
                          </Fragment>
                        ))}
                      </Fragment>
                    ))}
                  </ScrollToBottom>
                  {/* </ul> */}
                  <div class="bg-light bg-opacity-50 p-2">
                    <form
                      class="needs-validation"
                      name="chat-form"
                      id="chat-form"
                    >
                      <div class="row align-items-center">
                        <div class="col mb-2 mb-sm-0 d-flex">
                          <div class="input-group">
                            <a
                              href="javascript: void(0);"
                              class="btn btn-sm btn-light d-flex align-items-center input-group-text"
                            >
                              <i class="bx bx-smile fs-18"></i>
                            </a>
                            <input
                              type="text"
                              class="form-control border-0"
                              placeholder="Enter your message"
                              value={typedMessage || ''}
                              onChange={handleChange}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  handleSubmit(e);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div class="col-sm-auto">
                          <div class="">
                            {roomImageLoader ? (
                              <InfinitySpin width="80" color="#ED1D24" />
                            ) : (
                              <div class="btn-group btn-toolbar">
                                <a
                                  href="javascript: void(0);"
                                  class="btn btn-sm btn-light"
                                  style={{ position: 'relative' }}
                                >
                                  <i class="bx bx-paperclip fs-18"></i>

                                  <input
                                    type="file"
                                    multiple
                                    disabled={roomImageLoader}
                                    onChange={handleUploadImage}
                                    style={{
                                      position: 'absolute',
                                      opacity: 0,
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                    }}
                                  />
                                </a>
                                {/* <div className="btn-file btn">
                                <i className="feather-plus" />
                                <input
                                  type="file"
                                  multiple
                                  disabled={roomImageLoader}
                                  onChange={handleUploadImage}
                                />
                              </div> */}
                                {/* <a
                                  href="javascript: void(0);"
                                  class="btn btn-sm btn-light"
                                >
                                  <i class="bx bx-video fs-18"></i>
                                </a> */}
                                <button
                                  type="submit"
                                  class="btn btn-sm btn-primary chat-send"
                                  onClick={handleSubmit}
                                >
                                  <i class="bx bx-send fs-18"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserNormalChat;
